// Save combined job interview answers (requirements + company) ***********************************
// pathname: /v1/job-interview/{slug}/questions
// ************************************************************************************************
import { useSwrMutationApi } from '@hooks/useSwrApi';

/** Props */
interface UseSwrJobSaveCombinedAnswersProps {
  locale: Locale;
  jobSlug: string;
  successCallback?: () => void;
  errorCallback?: (error: ApiSchema<'ErrorResponse'>) => void;
}

/**
 * @description SWR mutation: save combined job interview answers (requirements + company text questions).
 * - `locale` - the current locale
 * - `jobSlug` - the job slug
 * - `successCallback` - callback to call on success
 * - `errorCallback` - callback to call on error
 */
export const useSwrJobSaveCombinedAnswers = (props: UseSwrJobSaveCombinedAnswersProps) => {
  const {
    locale,
    jobSlug,
    successCallback,
    errorCallback,
  } = props;

  return useSwrMutationApi<ApiSchema<'CombinedAnswersListRead'>, ApiSchema<'CombinedAnswersListWrite2'>>({
    url: `/v1/job-interview/${jobSlug}/questions`,
    locale,
    fetcherConfig: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess: () => {
        if (successCallback) successCallback();
      },
      onError: (error) => {
        if (errorCallback) errorCallback(error);
      },
    },
    toastsOptions: {
      showSuccessToast: false,
      showErrorToast: true,
    },
  });
};
